import { useEffect, useState } from 'react';

// True below Tailwind's `sm` breakpoint (640px) — phone-sized screens. Kept in JS (not just CSS
// hidden/block) so heavy trees like the Orders table aren't mounted at all on phones, where the
// card list renders instead.
export function useIsMobile(): boolean {
  const query = '(max-width: 639px)';
  const [isMobile, setIsMobile] = useState<boolean>(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isMobile;
}
